'use client'
import { useState, useEffect } from 'react'
import { FaUser } from 'react-icons/fa'
import { RadioGroup } from '@headlessui/react'
import { MdOutlinePhoneIphone, MdEmail } from 'react-icons/md'
import { sendContactPageForm } from '@services/sendContactPageForm'
import { useSession } from 'next-auth/react'
import tailwindConfig from '@tailwind.config'
import { Combobox, Listbox } from "@headlessui/react"
import { countryCodes } from '@constants/countryCodes'
import { RiArrowDropDownLine, RiLayoutGridLine } from 'react-icons/ri'
import { FaLine, FaWhatsappSquare, FaPhoneSquareAlt } from 'react-icons/fa'
import { AiFillInstagram, AiFillFacebook, /*AiFillLinkedin, AiFillTwitterSquare,*/ AiFillWechat } from 'react-icons/ai'
import { TbReportMoney } from 'react-icons/tb'
import { BiSolidBuildingHouse } from "react-icons/bi"
import { preferredContact } from '@constants/preferredContact';
import { contactReason } from '@constants/contactReason';
import { serviceCategoryTypes, serviceCondoRoomTypes, serviceHouseRoomTypes, serviceLandUnit } from '@constants';
import { company } from '@constants/company';
import {
  getCookies,
} from 'cookies-next';
import { useSearchParams } from 'next/navigation';

import Link from 'next/link'

const page = ({ dictionary, lang }) => {
    const searchParams = useSearchParams();

    const [isLoading, setIsLoading] = useState(false)
    const [userId, setUserId] = useState(null)
    const [phone, setPhone] = useState('')
    const [contact, setContact] = useState(preferredContact[lang][0])
    const [reason, setReason] = useState(contactReason[lang][0])
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState(``)
    const [hasEnquiry, setHasEnquiry] = useState(false)
    const [line, setLine] = useState('')
    const [wechat, setWechat] = useState('')
    const [selectedCountry, setSelectedCountry] = useState(countryCodes[0].code)
    const [query, setQuery] = useState('')
    const [budget, setBudget] = useState('')
    const [type, setType] = useState('')

    const [category, setCategory] = useState(serviceCategoryTypes[lang][0])
    const [area, setArea] = useState('')
    const [landUnit, setLandUnit] = useState(serviceLandUnit[lang][0])
    const [purpose, setPurpose] = useState('')
    const [room, setRoom] = useState(serviceCondoRoomTypes[lang][0])


    const filteredCountries =
        query === ''
            ? countryCodes
            : countryCodes.filter((country) => {
                return country.country.toLowerCase().includes(query.toLowerCase()) || country.code.toLowerCase().includes(query.toLowerCase())
            })

    useEffect(() => {
        const resetRooms = () => {
            if (category.value == 'house') {
                setRoom(serviceHouseRoomTypes[lang][0])
            }
            if (category.value == 'condo') {
                setRoom(serviceCondoRoomTypes[lang][0])
            }
        }
        resetRooms()
    }, [category])

    useEffect(() => {
        const setUserData = () => {
            const savedDetails = JSON.parse(localStorage.getItem('contactDetails'));

            if (savedDetails) {
                if (savedDetails.name && savedDetails.name !== '') {
                    setName(savedDetails.name);
                }
                if (savedDetails.selectedCountry && savedDetails.selectedCountry !== '') {
                    setSelectedCountry(savedDetails.selectedCountry);
                }
                if (savedDetails.phone && savedDetails.phone !== '') {
                    setPhone(savedDetails.phone);
                }
                if (savedDetails.email && savedDetails.email !== '') {
                    setEmail(savedDetails.email);
                }
                if (savedDetails.contact && savedDetails.contact !== '') {
                    setContact(savedDetails.contact);
                }
                if (savedDetails.line && savedDetails.line !== '') {
                    setLine(savedDetails.line);
                }
                if (savedDetails.wechat && savedDetails.wechat !== '') {
                    setWechat(savedDetails.wechat);
                }

            }
        }
        setUserData()
    }, [])

    const handleForm = async (e) => {
        e.preventDefault()

        setIsLoading(true)

        const cookies = getCookies()

        let likeCookies = undefined

        if (cookies.likes) likeCookies = cookies.likes

        const contactDetails = {
            name,
            selectedCountry,
            phone,
            email,
            contact,
            line,
            wechat
        };

        localStorage.setItem('contactDetails', JSON.stringify(contactDetails));

        const { sendGAEvent } = await import('@next/third-parties/google')

        sendGAEvent({ 
            event: "contactus_inquiry",
            user_email: email || 'not_provided',
            user_phonecall: `${selectedCountry}${phone?.replace(/[a-zA-Z\W]/g, '')}`,
            user_line: line || 'not_provided',
            reason: reason
        })

        const fbclid = searchParams.get('fbclid');

        const { sendContactPageForm } = await import('@services/sendContactPageForm')

        await sendContactPageForm({ 
            userId, 
            name, 
            selectedCountry, 
            phone, 
            email, 
            message, 
            contact, 
            line, 
            wechat, 
            reason, 
            budget, 
            type, 
            category, 
            area, 
            landUnit, 
            purpose, 
            room,
            likes: likeCookies,
            fbclid: fbclid ? fbclid : undefined
        })
        
        setHasEnquiry(true)
        setIsLoading(false)

    }

    const selectTextOnClick = (e) => {
        e.target.select();
    };

    return (
        <>
            <div className='sm:w-full 2xl:w-8/12 mx-auto pb-16'>
                <div className='flex flex-col px-3 mt-2 w-full'>
                    <h1 className='text-maincolor font-bold text-xl mb-2'>{dictionary.contactUs.title}</h1>
                    <div className='md:hidden w-full flex flex-col'>
                        <span className='text-maincolor'>{dictionary.contactUs.reachUsDirectly}</span>
                        <div className='w-full flex flex-col'>
                            <Link href={company.phoneUrl} className='flex flex-row justify-center border-[1px] bg-gradient-to-r from-[#C62121] to-[#b21515] py-2 px-4 my-1 items-center rounded-sm shadow-sm drop-shadow-md' target="_blank">
                                <div className='flex flex-row w-[220px] items-center'>
                                    <FaPhoneSquareAlt
                                        color={tailwindConfig.theme.extend.colors.light}
                                        size={30}
                                        className=''
                                    />
                                    <span className="w-full text-center text-light">{dictionary.contactUs.phoneButton}</span>
                                </div>
                            </Link>
                            <Link href={company.lineUrl} className='flex flex-row justify-center border-[1px] bg-gradient-to-r from-[#32CD32] to-[#2dbc2d] py-2 px-4 my-1 items-center rounded-sm shadow-sm drop-shadow-md' target="_blank">
                                <div className='flex flex-row w-[220px] items-center'>
                                    <FaLine
                                        color={tailwindConfig.theme.extend.colors.light}
                                        size={30}
                                        className=''
                                    />
                                    <span className="w-full text-center text-light">{dictionary.contactUs.lineButton}</span>
                                </div>
                            </Link>
                            <Link href={company.facebookUrl} className='flex flex-row justify-center border-[1px] bg-gradient-to-r from-[#1877f2] to-[#0866ff] py-2 px-4 my-1 items-center rounded-sm shadow-sm drop-shadow-md' target="_blank">
                                <div className='flex flex-row w-[220px] items-center'>
                                    <AiFillFacebook
                                        color={tailwindConfig.theme.extend.colors.light}
                                        size={30}
                                        className=''
                                    />
                                    <span className="w-full text-center text-light">{dictionary.contactUs.visitFacebook}</span>
                                </div>
                            </Link>
                            <Link href={company.instagramUrl} className='flex flex-row justify-center border-[1px]  bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 py-2 px-4 my-1 items-center rounded-sm shadow-sm drop-shadow-md' target="_blank">
                                <div className='flex flex-row w-[220px] items-center'>                                
                                    <AiFillInstagram
                                        color={tailwindConfig.theme.extend.colors.light}
                                        size={30}
                                        className=''
                                    />
                                    <span className="w-full text-center text-light">{dictionary.contactUs.visitInstagram}</span>
                                </div>
                            </Link>
                        </div>
                        <div className='w-full flex justify-center items-center mx-2'>
                            <span className='text-secondary'>{dictionary.contactUs.or}</span>
                        </div>
                        <div className='mb-1'>
                            <span className='text-maincolor'>{dictionary.contactUs.leaveAMessageBelow}</span>
                        </div>
                        {!hasEnquiry ? (
                            <div className='sm:w-1/2 w-full xl:mb-0 pb-3 xl:border-b-0 border-b-[1px] border-b-forth'>
                                <div className='w-full border-[1px] p-2 border-secondary rounded-sm'>
                                    <form onSubmit={handleForm}>
                                        <label className='text-secondary text-sm'>{dictionary.contactUs.name}</label>
                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                            <FaUser
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                size={28}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                placeholder={dictionary.contactUs.namePlaceholder}
                                                type='text'
                                                name='phone'
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <label className='text-secondary text-sm'>{dictionary.contactUs.contactReason}</label>
                                        <Listbox value={reason} onChange={setReason}>
                                            <div className='z-1 relative w-full cursor-default rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <Listbox.Button className="relative w-full cursor-default rounded-sm bg-white py-2 pl-3 pr-10 text-left focus:shadow-md focus:outline-none  sm:text-sm">
                                                    <span className="block truncate">{reason.name}</span>
                                                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                        <RiArrowDropDownLine
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={28}
                                                        />
                                                    </span>
                                                </Listbox.Button>
                                                <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-sm bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                                    {contactReason[lang].map((res, resId) => (
                                                        <Listbox.Option
                                                            key={resId}
                                                            className={({ active }) =>
                                                                `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                                }`
                                                            }
                                                            value={res}
                                                        >
                                                            {({ selected }) => (
                                                                <>
                                                                    <span
                                                                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                            }`}
                                                                    >
                                                                        {res.name}
                                                                    </span>
                                                                    {selected ? (
                                                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                            {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                                                                        </span>
                                                                    ) : null}
                                                                </>
                                                            )}
                                                        </Listbox.Option>
                                                    ))}
                                                </Listbox.Options>
                                            </div>
                                        </Listbox>
                                        <label className='text-secondary text-sm'>{dictionary.contactUs.preferredContact}</label>
                                        <Listbox value={contact} onChange={setContact}>
                                            <div className='z-1 relative w-full cursor-default rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <Listbox.Button className="relative w-full cursor-default rounded-sm bg-white py-2 pl-3 pr-10 text-left focus:shadow-md focus:outline-none  sm:text-sm">
                                                    <span className="block truncate">{contact.name}</span>
                                                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                        <RiArrowDropDownLine
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={28}
                                                        />
                                                    </span>
                                                </Listbox.Button>
                                                <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-sm bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                                    {preferredContact[lang].map((cont, contIdx) => (
                                                        <Listbox.Option
                                                            key={contIdx}
                                                            className={({ active }) =>
                                                                `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                                }`
                                                            }
                                                            value={cont}
                                                        >
                                                            {({ selected }) => (
                                                                <>
                                                                    <span
                                                                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                            }`}
                                                                    >
                                                                        {cont.name}
                                                                    </span>
                                                                    {selected ? (
                                                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                            {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                                                                        </span>
                                                                    ) : null}
                                                                </>
                                                            )}
                                                        </Listbox.Option>
                                                    ))}
                                                </Listbox.Options>
                                            </div>
                                        </Listbox>
                                        {(contact.value == 'phone' || contact.value == 'whatsapp' || contact.value == 'viber') && (
                                            <>
                                                <label className='text-secondary text-sm'>{dictionary.contactUs.phone}</label>
                                                <div className='flex flex-row w-full'>
                                                    {/* <CountryCode className="w-1/4" /> */}
                                                    <Combobox className="w-1/4"
                                                        value={selectedCountry}
                                                        onChange={setSelectedCountry}
                                                    >
                                                        <div className="relative w-full">
                                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                                <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' />
                                                                <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                                                                    <RiArrowDropDownLine
                                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                                        size={28}
                                                                    />
                                                                </Combobox.Button>
                                                            </div>
                                                            <Combobox.Options
                                                                as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                                className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-sm py-1'
                                                            >
                                                                {filteredCountries.map((country) => (
                                                                    <Combobox.Option
                                                                        key={country.id}
                                                                        value={country.code}
                                                                        className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                                    >
                                                                        {country.code} {country.country}
                                                                    </Combobox.Option>
                                                                ))}
                                                            </Combobox.Options>
                                                        </div>
                                                    </Combobox>
                                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                        <MdOutlinePhoneIphone
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={30}
                                                            className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                        />
                                                        <input
                                                            className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                            placeholder={dictionary.contactUs.phonePlaceholder}
                                                            required
                                                            type='text'
                                                            name='phone'
                                                            value={phone}
                                                            onChange={(e) => setPhone(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {(contact.value == 'line') && (
                                            <>
                                                <label className='text-secondary text-sm'>{dictionary.contactUs.line}</label>
                                                <div className='w-full py-1'>
                                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                        <FaLine
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={30}
                                                            className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                        />
                                                        <input
                                                            className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                            placeholder={dictionary.contactUs.linePlaceholder}
                                                            type='line'
                                                            name='line'
                                                            value={line}
                                                            onChange={(e) => setLine(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {(contact.value == 'wechat') && (
                                            <>
                                                <label className='text-secondary text-sm'>{dictionary.contactUs.wechat}</label>
                                                <div className='w-full py-1'>
                                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                        <AiFillWechat
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={30}
                                                            className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                        />
                                                        <input
                                                            className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                            placeholder={dictionary.contactUs.wechatPlaceholder}
                                                            type='wechat'
                                                            name='wechat'
                                                            value={wechat}
                                                            onChange={(e) => setWechat(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <label className='text-secondary text-sm'>{dictionary.contactUs.email}</label>
                                        <div className='w-full py-1'>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <MdEmail
                                                    color={tailwindConfig.theme.extend.colors.secondary}
                                                    size={30}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={dictionary.contactUs.emailPlaceholder}
                                                    type='email'
                                                    name='email'
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <label className='text-secondary text-sm'>{dictionary.contactUs.message}</label>
                                        <div className='w-full py-1'>
                                            <textarea
                                                className='w-full border-[1px] border-forth text-secondary rounded-sm p-2'
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                rows={3}
                                                required
                                            />
                                        </div>
                                        <button disabled={isLoading} className='w-full p-2 bg-third text-light font-bold rounded-sm' type='submit'>{dictionary.contactUs.send}</button>
                                    </form>
                                </div>
                            </div>
                            ) : (
                            <div className='sm:w-1/2 w-full flex flex-col items-center justify-center border-l-[1px] py-3'>
                                <h2 className='text-maincolor font-bold text-xl'>{dictionary.contactUs.messageSent}</h2>
                                <p className='text-secondary'>{dictionary.contactUs.enquirySentSubtitle}</p>
                            </div>
                        )}
                    </div>
                    <div className='hidden md:flex sm:flex-row flex-col w-full'>
                        <div className='sm:w-1/2 w-full'>
                            <div className='text-maincolor'>
                                <p className='mb-1 text-maincolor'>{company.name}</p>
                                <p className='mb-1 text-maincolor'>{company.phone1}</p>
                                <p className='mb-1 text-maincolor'>{company.phone2}</p>
                                <p className='mb-1 text-maincolor'>{company.email}</p>
                                <p className='mb-1 text-maincolor'>{company.address1}</p>
                                <p className='mb-1 text-maincolor'>{company.address2}</p>
                                <div className='flex flex-row'>
                                    <Link href={company.lineUrl} className='mr-2' target="_blank">
                                        <FaLine
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                            size={30}
                                            className=''
                                        />
                                    </Link>
                                    <Link href={company.facebookUrl} className='mr-2' target="_blank">
                                        <AiFillFacebook
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                            size={30}
                                            className=''
                                        />
                                    </Link>
                                    <Link href={company.whatsappUrl} className='mr-2' target="_blank">
                                        <FaWhatsappSquare
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                            size={30}
                                            className=''
                                        />
                                    </Link>
                                    <Link href={company.instagramUrl} className='mr-2' target="_blank">
                                        <AiFillInstagram
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                            size={30}
                                            className=''
                                        />
                                    </Link>
                                    {/* <Link href={`https:/x.com`} className='mr-2' target="_blank">
                                        <AiFillTwitterSquare
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                            size={30}
                                            className=''
                                        />
                                    </Link>
                                    <Link href={`https:/linkedin.com`} className='mr-2' target="_blank">
                                        <AiFillLinkedin
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                            size={30}
                                            className=''
                                        />
                                    </Link> */}
                                </div>
                            </div>
                        </div>
                        {!hasEnquiry ? (
                            <div className='sm:w-1/2 w-full xl:mb-0 pb-3 xl:border-b-0 border-b-[1px] border-b-forth'>
                                <div className='w-full border-[1px] p-2 border-secondary rounded-sm'>
                                    <form onSubmit={handleForm}>
                                        <label className='text-secondary text-sm'>{dictionary.contactUs.name}</label>
                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                            <FaUser
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                size={28}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                placeholder={dictionary.contactUs.namePlaceholder}
                                                type='text'
                                                name='phone'
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <label className='text-secondary text-sm'>{dictionary.contactUs.contactReason}</label>
                                        <Listbox value={reason} onChange={setReason}>
                                            <div className='z-1 relative w-full cursor-default rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <Listbox.Button className="relative w-full cursor-default rounded-sm bg-white py-2 pl-3 pr-10 text-left focus:shadow-md focus:outline-none  sm:text-sm">
                                                    <span className="block truncate">{reason.name}</span>
                                                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                        <RiArrowDropDownLine
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={28}
                                                        />
                                                    </span>
                                                </Listbox.Button>
                                                <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-sm bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                                    {contactReason[lang].map((res, resId) => (
                                                        <Listbox.Option
                                                            key={resId}
                                                            className={({ active }) =>
                                                                `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                                }`
                                                            }
                                                            value={res}
                                                        >
                                                            {({ selected }) => (
                                                                <>
                                                                    <span
                                                                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                            }`}
                                                                    >
                                                                        {res.name}
                                                                    </span>
                                                                    {selected ? (
                                                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                            {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                                                                        </span>
                                                                    ) : null}
                                                                </>
                                                            )}
                                                        </Listbox.Option>
                                                    ))}
                                                </Listbox.Options>
                                            </div>
                                        </Listbox>
                                        <label className='text-secondary text-sm'>{dictionary.contactUs.preferredContact}</label>
                                        <Listbox value={contact} onChange={setContact}>
                                            <div className='z-1 relative w-full cursor-default rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <Listbox.Button className="relative w-full cursor-default rounded-sm bg-white py-2 pl-3 pr-10 text-left focus:shadow-md focus:outline-none  sm:text-sm">
                                                    <span className="block truncate">{contact.name}</span>
                                                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                        <RiArrowDropDownLine
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={28}
                                                        />
                                                    </span>
                                                </Listbox.Button>
                                                <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-sm bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                                                    {preferredContact[lang].map((cont, contIdx) => (
                                                        <Listbox.Option
                                                            key={contIdx}
                                                            className={({ active }) =>
                                                                `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                                }`
                                                            }
                                                            value={cont}
                                                        >
                                                            {({ selected }) => (
                                                                <>
                                                                    <span
                                                                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                            }`}
                                                                    >
                                                                        {cont.name}
                                                                    </span>
                                                                    {selected ? (
                                                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                            {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                                                                        </span>
                                                                    ) : null}
                                                                </>
                                                            )}
                                                        </Listbox.Option>
                                                    ))}
                                                </Listbox.Options>
                                            </div>
                                        </Listbox>
                                        {(contact.value == 'phone' || contact.value == 'whatsapp' || contact.value == 'viber') && (
                                            <>
                                                <label className='text-secondary text-sm'>{dictionary.contactUs.phone}</label>
                                                <div className='flex flex-row w-full'>
                                                    {/* <CountryCode className="w-1/4" /> */}
                                                    <Combobox className="w-1/4"
                                                        value={selectedCountry}
                                                        onChange={setSelectedCountry}
                                                    >
                                                        <div className="relative w-full">
                                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                                <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' />
                                                                <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                                                                    <RiArrowDropDownLine
                                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                                        size={28}
                                                                    />
                                                                </Combobox.Button>
                                                            </div>
                                                            <Combobox.Options
                                                                as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                                className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-sm py-1'
                                                            >
                                                                {filteredCountries.map((country) => (
                                                                    <Combobox.Option
                                                                        key={country.id}
                                                                        value={country.code}
                                                                        className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                                    >
                                                                        {country.code} {country.country}
                                                                    </Combobox.Option>
                                                                ))}
                                                            </Combobox.Options>
                                                        </div>
                                                    </Combobox>
                                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                        <MdOutlinePhoneIphone
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={30}
                                                            className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                        />
                                                        <input
                                                            className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                            placeholder={dictionary.contactUs.phonePlaceholder}
                                                            required
                                                            type='text'
                                                            name='phone'
                                                            value={phone}
                                                            onChange={(e) => setPhone(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {(contact.value == 'line') && (
                                            <>
                                                <label className='text-secondary text-sm'>{dictionary.contactUs.line}</label>
                                                <div className='w-full py-1'>
                                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                        <FaLine
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={30}
                                                            className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                        />
                                                        <input
                                                            className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                            placeholder={dictionary.contactUs.linePlaceholder}
                                                            type='line'
                                                            name='line'
                                                            value={line}
                                                            onChange={(e) => setLine(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {(contact.value == 'wechat') && (
                                            <>
                                                <label className='text-secondary text-sm'>{dictionary.contactUs.wechat}</label>
                                                <div className='w-full py-1'>
                                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                        <AiFillWechat
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={30}
                                                            className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                        />
                                                        <input
                                                            className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                            placeholder={dictionary.contactUs.wechatPlaceholder}
                                                            type='wechat'
                                                            name='wechat'
                                                            value={wechat}
                                                            onChange={(e) => setWechat(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <label className='text-secondary text-sm'>{dictionary.contactUs.email}</label>
                                        <div className='w-full py-1'>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <MdEmail
                                                    color={tailwindConfig.theme.extend.colors.secondary}
                                                    size={30}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={dictionary.contactUs.emailPlaceholder}
                                                    type='email'
                                                    name='email'
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <label className='text-secondary text-sm'>{dictionary.contactUs.message}</label>
                                        <div className='w-full py-1'>
                                            <textarea
                                                className='w-full border-[1px] border-forth text-secondary rounded-sm p-2'
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                rows={3}
                                                required
                                            />
                                        </div>
                                        <button disabled={isLoading} className='w-full p-2 bg-third text-light font-bold rounded-sm' type='submit'>{dictionary.contactUs.send}</button>
                                    </form>
                                </div>
                            </div>
                            ) : (
                            <div className='sm:w-1/2 w-full flex flex-col items-center justify-center border-l-[1px] py-3'>
                                <h2 className='text-maincolor font-bold text-xl'>{dictionary.contactUs.messageSent}</h2>
                                <p className='text-secondary'>{dictionary.contactUs.enquirySentSubtitle}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default page